import React, { useState } from "react";
import { Check, ArrowRight } from "lucide-react";
import { postForm } from "../../../lib/forms";
import { track } from "../../../lib/analytics";

const field = "mt-1 w-full rounded-lg border border-brand-line bg-white px-3 py-2.5 text-sm text-brand-ink outline-none focus:border-brand-ink";

export const RecommendationForm = ({ defaultStyle = "" }) => {
  const [form, setForm] = useState({ name: "", email: "", destination: "", budget: "", message: "", retreat_style: defaultStyle });
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setError("");
    try {
      await postForm("recommendation-request", form);
      track("recommendation_request_submitted", { retreat_style: form.retreat_style || null });
      setStatus("done");
    } catch (err) {
      setStatus("error");
      setError(err.message);
    }
  };

  if (status === "done") {
    return (
      <div data-testid="recommendation-success" className="rounded-2xl border border-brand-line bg-white p-7">
        <div className="inline-flex items-center gap-2 text-brand-ink"><Check size={18} className="text-brand-terracotta" /> <span className="font-display text-xl">Request received</span></div>
        <p className="mt-2 text-sm text-brand-inkSoft">Thanks! We&apos;ll come back with a hand-picked recommendation soon.</p>
      </div>
    );
  }

  return (
    <form data-testid="recommendation-form" onSubmit={submit} className="rounded-2xl border border-brand-line bg-white p-7">
      <p className="overline text-brand-inkSoft">For travellers</p>
      <h3 className="mt-2 font-display text-2xl text-brand-ink">Request a recommendation</h3>
      <p className="mt-1 text-sm text-brand-inkSoft">Tell us what you&apos;re after and we&apos;ll suggest retreats that fit.</p>
      <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
        <label className="block"><span className="text-xs text-brand-inkSoft">Name</span><input data-testid="rec-name" required value={form.name} onChange={set("name")} className={field} /></label>
        <label className="block"><span className="text-xs text-brand-inkSoft">Email</span><input data-testid="rec-email" type="email" required value={form.email} onChange={set("email")} className={field} /></label>
        <label className="block"><span className="text-xs text-brand-inkSoft">Destination (optional)</span><input data-testid="rec-destination" value={form.destination} onChange={set("destination")} className={field} /></label>
        <label className="block"><span className="text-xs text-brand-inkSoft">Budget (optional)</span><input data-testid="rec-budget" value={form.budget} onChange={set("budget")} className={field} /></label>
      </div>
      <label className="mt-3 block"><span className="text-xs text-brand-inkSoft">What are you looking for?</span><textarea data-testid="rec-message" rows={3} value={form.message} onChange={set("message")} className={field} /></label>
      {status === "error" && <p data-testid="rec-error" className="mt-3 text-sm text-red-600">{error}</p>}
      <button data-testid="rec-submit" type="submit" disabled={status === "loading"} className="mt-5 inline-flex items-center gap-2 rounded-full bg-brand-ink px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-brand-inkSoft disabled:opacity-60">
        {status === "loading" ? "Sending…" : "Request a Recommendation"} <ArrowRight size={15} />
      </button>
    </form>
  );
};

export default RecommendationForm;
